import React, { useState, useEffect } from 'react';
import { createUseStyles } from 'react-jss';
import { Container, Grid, GridColumn, Form } from 'semantic-ui-react';
import 'flatpickr/dist/themes/airbnb.css';
import Flatpickr from 'react-flatpickr';
import Moment from 'moment';
import './Search.css';
import { listRoomTypeByAvailability } from '@/api/roomTypeAPI';
import { availability } from '@/api/roomTypeAPI';
import { listPropertyByCompany } from '@/api/propertyAPI';
// import { sortBy } from 'lodash';
import { useDispatch } from 'react-redux';
import { submitSearch } from '@/components/searchSlice';
import { setResults } from '@/components/searchSlice';
import { useLocation } from 'react-router-dom';
import Colors from '@/constants/colors';
import IconButtons from '@/components/Buttons/IconButtons';
import { menuSelector } from '@/store/selector';
import { sessionSelector } from '@/store/selector';
import { MENU_ITEMS, SORT_ITEMS } from 'utils/constants';
import { searchSelector } from '@/store/selector';
import { companySelector } from '@/store/selector';
import RoomTypeItem from '@/components/common/RoomTypeItem';
import { setRoomType } from '@/components/searchSlice';
import { setRates } from '@/components/searchSlice';
import { setAvailability } from '../searchSlice';
import { setCanShowCheckoutButton } from '../cartSlice';
import { cartSelector } from '@/store/selector';
import CheckoutPanel from '@/components/checkout/CheckoutPanel';
import LeftCheckoutPanel from '@/components/checkout/LeftCheckoutPanel';
import RightCheckoutPanel from '@/components/checkout/RightCheckoutPanel';
import { setCartError } from '@/components/cartSlice';
import CartHelper from '@/helpers/cartHelper';
import { getStripeCredentials } from '@/api/stripeAPI';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import Breakpoints from '@/constants/breakpoints';
import { selectItem } from '@/components/menuSlice';

const useStyles = createUseStyles(
  {
    search: (properties) => ({
      '& .selected, .startRange, .endRange, .selected:hover, .startRange:hover, .endRange:hover, .today:hover':
        {
          backgroundColor: properties.propertyColor,
          borderColor: properties.propertyColor + ' !important',
          color: properties.fontColor + ' !important',
        },
      '& .today': {
        borderBottomColor: properties.propertyColor + ' !important',
      },
    }),
    grid: {
      height: '100%',
      marginTop: '0px !important',
      backgroundColor: Colors.whiteOne,
      cursor: 'pointer',
    },
    searchLeft: {
      borderRight: `1px solid ${Colors.grayFour};`,
    },
    searchCenter: {
      borderRight: `1px solid ${Colors.grayFour};`,
      paddingTop: '25px !important',
    },
    searchButton: {
      backgroundColor: Colors.blackTwo,
      color: Colors.whiteOne,
      height: '74px',
      paddingTop: '28px !important',
      cursor: 'pointer',
    },
    searchPanel: {
      position: 'fixed',
      width: '100% !important',
      height: '350px',
      backgroundColor: Colors.whiteOne,
      bottom: '75px',
      left: '0',
      transform: 'translateY(138%)',
      transition: 'transform .75s cubic-bezier(.23,1,.32,1)',
      zIndex: 9,
    },
    searchPanelActive: {
      transform: 'translateY(0) !important',
    },
    resultPanel: {
      position: 'fixed',
      width: '100% !important',
      height: '100%',
      backgroundColor: Colors.whiteOne,
      top: '0',
      left: '0',
      transform: 'translateY(100%)',
      transition: 'transform .75s cubic-bezier(.9,1,.32,1)',
      transitionDelay: '0s',
      zIndex: 99999,
      overflow: 'scroll',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
    resultPanelActive: {
      composes: ['$resultPanel'],
      transform: 'translateY(4%) !important',
      transitionDelay: '.75s !important',
    },
    checkoutPanel: {
      position: 'fixed',
      width: '100% !important',
      height: '100%',
      backgroundColor: Colors.whiteOne,
      bottom: '75px',
      left: '0',
      transform: 'translateY(100%)',
      transition: 'transform .75s cubic-bezier(.9,1,.32,1)',
      zIndex: 9999999,
      overflow: 'scroll',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
      display: 'none',
    },
    checkoutPanelShowed: {
      composes: ['$checkoutPanel'],
      display: 'block',
    },
    checkoutPanelActive: {
      composes: ['$checkoutPanel'],
      transform: 'translateY(calc(0% + 75px)) !important',
      display: 'block',
    },
    checkoutPanelTop: {
      width: '100%',
      height: '75px',
      backgroundColor: '#000',
      color: '#fff',
      textAlign: 'center',
      padding: '25px',
      cursor: 'pointer',
    },
    checkoutBack: {
      display: 'none',
    },
    checkoutBackActive: {
      composes: ['$checkoutBack'],
      display: 'block',
    },
    searchResponsivePanel: {
      position: 'fixed',
      width: '100% !important',
      height: '100%',
      backgroundColor: Colors.whiteOne,
      top: '0',
      left: '0',
      transform: 'translateY(138%)',
      transition: 'transform .75s cubic-bezier(.23,1,.32,1)',
      zIndex: 99,
      borderTop: '1px solid #ccc',
    },
    searchResponsivePanelActive: {
      composes: ['$searchResponsivePanel'],
      transform: 'translateY(0) !important',
    },
    searchDatesPanel: {
      position: 'fixed',
      width: '100% !important',
      height: '100%',
      backgroundColor: Colors.whiteOne,
      top: '65px',
      right: '0',
      transform: 'translateX(138%)',
      transition: 'transform .75s cubic-bezier(.23,1,.32,1)',
      zIndex: 99,
      borderTop: '1px solid #ccc',
    },
    searchDatesPanelActive: {
      composes: ['$searchResponsivePanel'],
      transform: 'translateX(0) !important',
    },
    noResultContainer: {
      backgroundColor: Colors.blueTwo,
      height: '60px',
      width: '100%',
      position: 'fixed',
      textAlign: 'center',
      zIndex: 0,
      '& p': {
        color: Colors.whiteOne,
        // font-family: "Work-Sans", sans-serif,
        fontSize: '1rem',
        fontWeight: 'bold',
        margin: 0,
        lineHeight: '60px',
        display: 'inline-block',
        // padding: '30px 50px',
      },
      transition: 'transform .75s cubic-bezier(.23,1,.32,1)',
      transform: 'translateY(0px)',
      bottom: '-60px'
    },
    noResultContainerActive: {
      composes: ['$noResultContainer'],
      transform: 'translateY(-135px) !important',
    },
    closeNoresultContainer: {
      float: 'right',
      position: 'relative',
      top: '15px',
      backgroundColor: 'transparent !important',
      '& i': {
        color: `${Colors.whiteOne} !important`,
      },
    },
    closeSearchButton: {
      float: 'right',
      position: 'relative',
      top: '-5px',
      right: '50px',
      backgroundColor: 'transparent !important',
      '& i': {
        fontSize: '1.2rem',
        color: `${Colors.blackTwo} !important`,
      },
    },
    closeSearchDatesButton: {
      position: 'absolute',
      top: '65px',
      right: '0px',
      left: '0px',
      marginRight: '0px !important',
      marginLeft: '0px !important',
      backgroundColor: 'transparent !important',
      '& i': {
        fontSize: '25px',
        color: `${Colors.blackTwo} !important`,
      },
    },
    content: {
      display: 'inline-block',
      width: '100%',
      paddingTop: '25px',
    },
    searchContainer: {
      width: '100% !important',
      height: '100%',
      borderTop: '1px solid #ccc',
      borderBottom: '1px solid #ccc',
      position: 'fixed',
      top: '0px',
      zIndex: '999',
      transform: 'translateY(calc(100% - 75px))',
      transition: 'transform 0.90s cubic-bezier(.7,1,.32,1)',
      backgroundColor: '#fff',
    },
    searchContainerActive: {
      composes: ['$searchContainer'],
      transform: 'translateY(0%)',
      '& $searchButton': {
        display: 'none !important',
      },
      '& $searchPanelBack': {
        display: 'block !important',
      },
    },
    searchViewAll: {
      padding: '25px !important',
      borderRight: '1px solid #ccc !important',
      paddingLeft: '60px !important',
      display: 'none !important',
    },
    searchViewAllActive: {
      composes: ['$searchViewAll'],
      display: 'block !important',
    },
    searchPanelBack: {
      padding: '25px !important',
      borderRight: '1px solid #ccc !important',
      paddingLeft: '60px !important',
      display: 'none !important',
    },
    searchPanelBackWithRoomType: {
      composes: ['$searchPanelBack'],
      borderRight: 'none !important',
    },
    [`@media (max-width: 1200px)`]: {
      resultPanel: {
        zIndex: '999999 !important',
      },
      searchContainer: {
        display: 'none',
      },
      resultPanelActive: {
        transform: 'translateY(0%) !important',
        top: '35px !important'
      },
      noResultContainer: {
        zIndex: '99 !important',
        padding: '12px',
        height: '110px !important',
        '& p': {
          lineHeight: '22px !important'
        }
      },
      closeNoresultContainer: {
        top: '-108px !important',
        right: '-26px !important',
        fontSize: '15px !important'
      },
    },
    [`@media (max-width: ${Breakpoints.xxl}px)`]: {
      resultPanelActive: {
        top: '60px',
      },
    },
    [`@media (min-width: 2300px)`]: {
      resultPanelActive: {
        transform: 'translateY(8%) !important',
      },
    },
  },
  { name: 'Search' },
);
const Search = ({ prop, handleItemSelected }) => {
  const location = useLocation();
  const parameters = new URLSearchParams(location.search);
  const dispatch = useDispatch();
  const menu = menuSelector();
  const search = searchSelector();
  const cart = cartSelector();
  const session = sessionSelector();
  const company = companySelector();
  const classes = useStyles({
    propertyColor: search.property != null ? search.property.color : '',
    fontColor: search.property != null ? search.property.fontColor : '',
  });
  const [show, setShow] = useState({ show: false });
  // const [showSearchPanel, setShowSearchPanel] = useState({ showSearch: false });
  const [showResponsive, setShowResponsive] = useState({ showResponsive: false });
  const [showDatesPanel, setShowDates] = useState({ showDatesPanel: false });
  const [showNoResult, setShowNoResult] = useState(false);
  const [showResults, setShowResults] = useState(false);
  const [adults, setAdults] = useState(2);
  const [childenrs, setChildrens] = useState(0);
  const [searchParams, setSearchParams] = useState({ arrival: null, departure: null });
  const [properties, setProperties] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadingCalendar, setLoadingCalendar] = useState(false);
  const [property, setProperty] = useState({ id: null, name: null });
  const [openCheckout, setOpenCheckout] = useState(false);
  const [externalUrlFulfilled, setExternalUrlFulfilled] = useState(false);
  const [defaultResults, setDefaultResults] = useState(null);
  const {total} = CartHelper.cartSummary(cart);

  const [stripePromise, setStripePromise] = useState(null);

  let checkoutPanelClass = classes.checkoutPanel;
  if (cart.items !== null && cart.items.length > 0) {
    checkoutPanelClass = classes.checkoutPanelShowed;
  }
  if (openCheckout) {
    checkoutPanelClass = classes.checkoutPanelActive;
  }

  if (property.id === null){
    setProperty({ id: prop.id, name: prop.name, defaultRoomTypeImage: prop.defaultRoomIamgeUrl });
  }
  //const showCheckout = cart.items !== null && cart.items.length > 0;

  const viewAllRoomsClick = () => {
    setShow(false);
    dispatch(
      selectItem({
        item: MENU_ITEMS.ROOMS,
      }),
    );
    removeRoomType();
  };
  const viewAllRoomsResponsiveClick = () => {
    setShowResponsive(false);
    dispatch(
      selectItem({
        item: MENU_ITEMS.ROOMS,
      }),
    );
  };
  const onSortChange = (event) => {
    var value = event.target.value;
    var results;
    if (value !== SORT_ITEMS.DEFAULT) {
      setDefaultResults(search.results);
    }
    if (value === SORT_ITEMS.PRICE_HIGH_TO_LOW) {
      results = [...search.results].sort((a, b) => b.averageNightlyRate - a.averageNightlyRate);
    } else if (value === SORT_ITEMS.PRICE_LOW_TO_HIGH) {
      results = [...search.results].sort((a, b) => a.averageNightlyRate - b.averageNightlyRate);
    } else if (value === SORT_ITEMS.OCCUPANCY_HIGH_TO_LOW) {
      results = [...search.results].sort((a, b) => a.roomsAvailable - b.roomsAvailable);
    } else if (value === SORT_ITEMS.OCCUPANCY_LOW_TO_HIGH) {
      results = [...search.results].sort((a, b) => b.roomsAvailable - a.roomsAvailable);
    } else if (value === SORT_ITEMS.DEFAULT) {
      results = defaultResults;
    }
    dispatch(
      setResults({
        results: results,
      }),
    );
  };
  const divCLick = () => {
    if (showResults === null || showResults === false) {
      setShow(true);
    }
    if (cart.canShowCheckoutButton) {
      backClick();
      setShow(true);
    }
  };
  const backClick = () => {
    setShowResults(false);
    dispatch(setCanShowCheckoutButton(false));
  };
  const viewAllClick = () => {
    removeRoomType();
    onSearchClick({ withoutRoomType: true });
  };
  const bookResponsiveCLick = () => {
    setShowResponsive(true);
  };
  const datesCLick = () => {
    setShowDates(true);
  };
  const addAdultsValue = () => {
    setAdults(adults + 1);
  };
  const subtractAdultsValue = () => {
    if (adults - 1 > 0) {
      setAdults(adults - 1);
    }
  };
  const addChildrensValue = () => {
    setChildrens(childenrs + 1);
  };
  const subtractChildrensValue = () => {
    if (childenrs - 1 >= 0) {
      setChildrens(childenrs - 1);
    }
  };
  const datesChanged = ([arrival, departure]) => {
    setSearchParams({ arrival: arrival, departure: departure });
    if (arrival != null && departure != null) {
      setShowDates(false);
    }
  };
  const propertySelected = (p) => {
    setProperty({ id: p.id, name: p.name, defaultRoomTypeImage: p.defaultRoomIamgeUrl });
    // navigate('/availability/property/?property=' + p.id);
  };
  const allResortsClicked = () => {
    setProperty({ id: null, name: null, defaultRoomTypeImage: null });
  };
  const removeRoomType = () => {
    dispatch(
      setRoomType({
        roomType: null,
      }),
    );
  };
  const onSearchClick = ({ withoutRoomType }) => {
    setLoading(true);
    setShowNoResult(false);
    var params = {
      propertyIdList: property.id !== null ? [property.id] : [],
      roomTypeIdList:
        (!withoutRoomType || withoutRoomType === null) && search.roomType !== null
          ? [search.roomType.id]
          : [],
      checkInDate: searchParams.arrival,
      checkOutDate: searchParams.departure,
      people: adults + childenrs,
    };
    listRoomTypeByAvailability(params)
      .then((response) => {
        /* const bookingSearchByDatesResponseItems = sortBy(response.data.itemList, [
          'roomType.sleeps',
          'averageNightlyRate',
        ]); */
        const bookingSearchByDatesResponseItems = response.data.itemList;
        if (bookingSearchByDatesResponseItems.length == 0) {
          setShowNoResult(true);
        } else {
          setShowResults(true);
          dispatch(setCanShowCheckoutButton(true));
        }
        dispatch(
          submitSearch({
            arrival: searchParams.arrival,
            departure: searchParams.departure,
            people: adults + childenrs,
            results: bookingSearchByDatesResponseItems,
          }),
        );
      })
      .finally(() => {
        setShow(false);
        setLoading(false);
      });
  };
  const params = {
    companyId: '1',
  };

  const handleLoading = () => {
    setLoading(false);
  };

  useEffect(() => {
    if (openCheckout) {
      dispatch(setCartError({ message: null }));
      let property = CartHelper.findCartProperty(cart);
      if (property) {
        getStripeCredentials(property.id)
          .then((res) => {
            let stripeCredentials = res.data;
            setStripePromise(loadStripe(stripeCredentials.publicKey));
          })
          .catch(onStripeCredentialError);
      }
      if (document.readyState === 'complete') {
        handleLoading();
      } else {
        window.addEventListener('load', handleLoading);
        return () => {
          window.removeEventListener('load', handleLoading);
        };
      }
    }
  }, [openCheckout]);

  const onStripeCredentialError = (error) => {
    dispatch(setCartError({ message: error.response.data }));
  };

  useEffect(() => {
    setShowResponsive(false);
    listPropertyByCompany(params).then((res) => {
      setProperties(res.data);
      if (company?.property) {
        let propertyId = company.property.id;
        res.data.forEach((property) => {
          if (propertyId == property.id) {
            setProperty({
              id: property.id,
              name: property.name,
              defaultRoomTypeImage: property.defaultRoomIamgeUrl,
            });
          }
        });
      }

      let adult = null;
      if (parameters.get('adult')) {
        adult = parseInt(parameters.get('adult'), 0);
        setAdults(adult);
      }

      let checkin = null;
      let checkout = null;
      if (parameters.get('checkin') && parameters.get('checkout')) {
        checkin = new Date(Number(parameters.get('checkin')) * 1000);
        checkout = new Date(Number(parameters.get('checkout')) * 1000);
        checkin = new Date(checkin.valueOf() + checkin.getTimezoneOffset() * 60000);
        checkout = new Date(checkout.valueOf() + checkout.getTimezoneOffset() * 60000);
        datesChanged([checkin, checkout]);
      }

      if (adult && checkin && checkout) {
        setExternalUrlFulfilled(true);
      }
    });
  }, [session]);

  useEffect(() => {
    if (externalUrlFulfilled) {
      onSearchClick({ withoutRoomType: false });
    }
  }, [externalUrlFulfilled]);

  useEffect(() => {
    if (menu.item === MENU_ITEMS.BOOK) {
      setShow(true);
    }
    if (menu.item === MENU_ITEMS.BOOKRESPONSIVE) {
      setShowResponsive(true);
    }
  }, [menu.item]);

  useEffect(() => {
    setShow(menu.showSearch);
  }, [menu.showSearch]);

  useEffect(() => {
    var propertyParams = {
      propertyIdList: search.property !== null ? [search.property.id] : [],
    };
    availability(propertyParams)
      .then((response) => {
        let availability = [];
        for (let i = 0; i < response.data.itemList.length; i++) {
          if (response.data.itemList[i].roomsAvailable > 0) {
            availability.push(response.data.itemList[i].date);
          }
        }
        dispatch(
          setAvailability({
            availability: availability,
          }),
        );
      })
      .finally(() => {});
  }, []);

  useEffect(() => {
    if (search.roomType !== null) {
      if (search.windowSize != null && search.windowSize < 1200) {
        setShowResponsive(true);
      } else {
        setShow(true);
      }
      setLoadingCalendar(true);
      var params = {
        roomTypeIdList: search.roomType !== null ? [search.roomType.id] : [],
      };
      availability(params)
        .then((response) => {
          let rates = [];
          for (let i = 0; i < response.data.itemList.length; i++) {
            rates[response.data.itemList[i].date] = response.data.itemList[i].rate;
          }
          let availability = [];
          for (let i = 0; i < response.data.itemList.length; i++) {
            if (response.data.itemList[i].roomsAvailable > 0) {
              availability.push(response.data.itemList[i].date);
            }
          }
          dispatch(
            setRates({
              rates: rates,
            }),
          );
          dispatch(
            setAvailability({
              availability: availability,
            }),
          );
        })
        .finally(() => {
          setLoadingCalendar(false);
        });
    } else {
      var propertyParams = {
        propertyIdList: search.property !== null ? [search.property.id] : [],
      };
      availability(propertyParams)
        .then((response) => {
          let availability = [];
          for (let i = 0; i < response.data.itemList.length; i++) {
            if (response.data.itemList[i].roomsAvailable > 0) {
              availability.push(response.data.itemList[i].date);
            }
          }
          dispatch(
            setAvailability({
              availability: availability,
            }),
          );
        })
        .finally(() => {});
    }
  }, [search.roomType]);

  return (
    <div className={classes.search}>
      {showResponsive === false && (
        <a className="book-responsive" onClick={bookResponsiveCLick}>
          Book
        </a>
      )}
      {showResponsive === true && (
        <Form className="book-responsive" loading={loading} onClick={onSearchClick}>
          <div>Search</div>
        </Form>
      )}
      <div
        className={
          showResponsive === true
            ? classes.searchResponsivePanelActive
            : classes.searchResponsivePanel
        }
      >
        <Container>
          <IconButtons.Close
            className={classes.closeSearchDatesButton}
            onClick={() => setShowResponsive(false)}
          />
          <div className="search-content">
            <Grid columns={1} className="roomtype-responsive-grid">
              <GridColumn textAlign="center">
                {search.roomType != null && (
                  <div className="roomtype-responsive">
                    {search.roomType.name}{' '}
                    <a className="remove-roomtype-button" onClick={removeRoomType}>
                      Remove x
                    </a>
                  </div>
                )}
              </GridColumn>
            </Grid>
            <Grid columns={1}>
              <GridColumn textAlign="center">
                <div className="dates-content">
                  <Grid columns={3} onClick={datesCLick}>
                    <GridColumn textAlign="center">
                      {searchParams.arrival != null
                        ? Moment(searchParams.arrival).format('MM/D/YYYY')
                        : 'Arrival'}
                    </GridColumn>
                    <GridColumn textAlign="center">
                      <i className="arrow right icon"></i>{' '}
                    </GridColumn>
                    <GridColumn textAlign="center">
                      {searchParams.departure != null
                        ? Moment(searchParams.departure).format('MM/D/YYYY')
                        : 'Departure'}
                    </GridColumn>
                  </Grid>
                </div>
              </GridColumn>
            </Grid>
            <Grid columns={1}>
              <GridColumn textAlign="center">
                <Grid columns={2}>
                  <GridColumn textAlign="left" className="adults">
                    <label>{adults}</label> {adults > 1 ? 'adults' : 'adult'}
                  </GridColumn>
                  <GridColumn textAlign="right" className="guest-butttons-container">
                    <a
                      className={
                        adults > 1
                          ? 'guest-button guest-button-left'
                          : 'guest-button guest-button-left guest-button-disabled'
                      }
                      onClick={subtractAdultsValue}
                    >
                      -
                    </a>
                    <a
                      className="guest-button guest-button-right guest-button-right-responsive"
                      onClick={addAdultsValue}
                    >
                      +
                    </a>
                  </GridColumn>
                </Grid>
                <Grid columns={2}>
                  <GridColumn textAlign="left" className="adults">
                    <label>{childenrs}</label> {childenrs > 0 ? 'childrens' : 'children'}
                  </GridColumn>
                  <GridColumn textAlign="right" className="guest-butttons-container">
                    <a
                      className={
                        childenrs > 0
                          ? 'guest-button guest-button-left'
                          : 'guest-button guest-button-left guest-button-disabled'
                      }
                      onClick={subtractChildrensValue}
                    >
                      -
                    </a>
                    <a className="guest-button guest-button-right" onClick={addChildrensValue}>
                      +
                    </a>
                  </GridColumn>
                </Grid>
              </GridColumn>
            </Grid>
            <Grid>
              <GridColumn textAlign="center">
                <a className="view-all-rooms-link" onClick={viewAllRoomsResponsiveClick}>
                  View All Rooms
                </a>
              </GridColumn>
            </Grid>
          </div>
        </Container>
      </div>
      <div
        className={
          showDatesPanel === true ? classes.searchDatesPanelActive : classes.searchDatesPanel
        }
      >
        <Container>
          <IconButtons.Close
            className={classes.closeSearchDatesButton}
            onClick={() => setShowDates(false)}
          />
          <div className="search-content">
            <Flatpickr
              options={{
                inline: true,
                mode: 'range',
                minDate: 'today',
                enable: search.availability,
              }}
              onChange={datesChanged}
              onDayCreate={(dObj, dStr, fp, dayElem) => {
                if (search.roomType != null) {
                  if (search.rates[Moment(dayElem.dateObj).format('YYYY-MM-DD')] != null) {
                    dayElem.innerHTML =
                      "<span class='calendar-date'>" + dayElem.innerHTML + '</span>';
                    dayElem.innerHTML +=
                      "<span class='rate'>$" +
                      search.rates[Moment(dayElem.dateObj).format('YYYY-MM-DD')] +
                      '</span>';
                  }
                }
              }}
            />
            <div
              className={
                loadingCalendar === true
                  ? 'calendar-dimmer calendar-dimmer-active'
                  : 'calendar-dimmer'
              }
            >
              <Form className="calendar-dimmer-form" loading={loadingCalendar}></Form>
            </div>
          </div>
        </Container>
      </div>
      <Container
        className={
          show === true ? [classes.searchPanel, classes.searchPanelActive] : classes.searchPanel
        }
      >
        <Grid columns={3}>
          <GridColumn textAlign="left" className="resorts-results">
            {search.property.multipleProperties && (
              <div>
                <div
                  className={
                    property.id == null ? 'resort-item resort-item-selected' : 'resort-item'
                  }
                  onClick={allResortsClicked}
                >
                  All Resorts
                </div>
                {properties.length > 0 &&
                  properties.map((p, idx) => (
                    <div
                      className={
                        property.id != null && property.id == p.id
                          ? 'resort-item resort-item-selected'
                          : 'resort-item'
                      }
                      key={idx}
                      onClick={() => propertySelected(p)}
                    >
                      {p.name}
                    </div>
                  ))}
              </div>
            )}
            {!search.property.multipleProperties && (
              <div className="resort-item resort-item-selected">{property.name}</div>
            )}
            {search.roomType != null && (
              <div className="resort-item resort-item-selected">
                {search.roomType.name}{' '}
                <a className="remove-roomtype-button" onClick={removeRoomType}>
                  Remove x
                </a>
              </div>
            )}
            <a className="view-all-rooms-link" onClick={viewAllRoomsClick}>
              View All Rooms
            </a>
          </GridColumn>
          <GridColumn textAlign="center">
            <Flatpickr
              options={{
                inline: true,
                mode: 'range',
                minDate: 'today',
                enable: search.availability,
              }}
              onChange={datesChanged}
              onDayCreate={(dObj, dStr, fp, dayElem) => {
                if (search.roomType != null) {
                  if (search.rates[Moment(dayElem.dateObj).format('YYYY-MM-DD')] != null) {
                    dayElem.innerHTML =
                      "<span class='calendar-date'>" + dayElem.innerHTML + '</span>';
                    dayElem.innerHTML +=
                      "<span class='rate'>$" +
                      search.rates[Moment(dayElem.dateObj).format('YYYY-MM-DD')] +
                      '</span>';
                  }
                }
              }}
            />
            <div
              className={
                loadingCalendar === true
                  ? 'calendar-dimmer calendar-dimmer-active'
                  : 'calendar-dimmer'
              }
            >
              <Form className="calendar-dimmer-form" loading={loadingCalendar}></Form>
            </div>
          </GridColumn>
          <GridColumn textAlign="right">
            <Grid columns={1}>
              <GridColumn textAlign="center" className="guest-tittle">
                Guests
                <IconButtons.Close
                  className={classes.closeSearchButton}
                  onClick={() => setShow(false)}
                />
              </GridColumn>
            </Grid>
            <Grid columns={2}>
              <GridColumn textAlign="right" className="adults">
                <label>{adults}</label> {adults > 1 ? 'adults' : 'adult'}
              </GridColumn>
              <GridColumn textAlign="left" className="guest-butttons-container">
                <a
                  className={adults > 1 ? 'guest-button' : 'guest-button guest-button-disabled'}
                  onClick={subtractAdultsValue}
                >
                  -
                </a>
                <a className="guest-button guest-button-right" onClick={addAdultsValue}>
                  +
                </a>
              </GridColumn>
            </Grid>
            <Grid columns={2}>
              <GridColumn textAlign="right" className="adults">
                <label>{childenrs}</label> {childenrs > 0 ? 'childrens' : 'children'}
              </GridColumn>
              <GridColumn textAlign="left" className="guest-butttons-container">
                <a
                  className={childenrs > 0 ? 'guest-button' : 'guest-button guest-button-disabled'}
                  onClick={subtractChildrensValue}
                >
                  -
                </a>
                <a className="guest-button guest-button-right" onClick={addChildrensValue}>
                  +
                </a>
              </GridColumn>
            </Grid>
          </GridColumn>
        </Grid>
      </Container>
      <div
          className={!showNoResult ? classes.noResultContainer : classes.noResultContainerActive}
        >
          <p>
          There is a night or night(s) in the date range searched that require a longer length of stay for these dates. Please contact us directly to review your available options:{' '}
            {search.property.contact.phone}
          </p>
          <IconButtons.Close
            className={classes.closeNoresultContainer}
            onClick={() => setShowNoResult(false)}
          />
        </div>
      <div
        className={showResults === true ? [classes.searchContainerActive] : classes.searchContainer}
      >
        <Form className="search-form" loading={loading} onClick={divCLick}>
          <Grid className={classes.grid} columns="equal">
            <GridColumn
              className={
                search.roomType !== null && showResults
                  ? classes.searchPanelBackWithRoomType
                  : classes.searchPanelBack
              }
              textAlign="left"
              onClick={backClick}
            >
              <i className="arrow left icon"></i> Back
            </GridColumn>
            <GridColumn
              className={
                search.roomType !== null && showResults
                  ? classes.searchViewAllActive
                  : classes.searchViewAll
              }
              textAlign="right"
              onClick={viewAllClick}
            >
              View All Rooms
            </GridColumn>
            <GridColumn className="resorts" textAlign="left">
              <div className={search.roomType != null ? 'search-property-name-large' : 'search-property-name-short'}>
                {property.id != null ? property.name : 'All Resorts'}{' '}
                {search.roomType != null ? '(' + search.roomType.name + ')' : ''}
              </div>
            </GridColumn>
            <GridColumn className={classes.searchCenter} textAlign="center">
              <Grid columns={3}>
                <GridColumn textAlign="center">
                  {searchParams.arrival != null
                    ? Moment(searchParams.arrival).format('MM/D/YYYY')
                    : 'Arrival'}
                </GridColumn>
                <GridColumn textAlign="center">
                  <i className="arrow right icon"></i>{' '}
                </GridColumn>
                <GridColumn textAlign="center">
                  {searchParams.departure != null
                    ? Moment(searchParams.departure).format('MM/D/YYYY')
                    : 'Departure'}
                </GridColumn>
              </Grid>
            </GridColumn>
            <GridColumn textAlign="center">
              <Grid columns="equal">
                <GridColumn textAlign="center" m className="guest-section">
                  <label>{childenrs + adults}</label> Guests
                </GridColumn>
                <GridColumn
                  onClick={onSearchClick}
                  className={classes.searchButton}
                  textAlign="center"
                >
                  Search
                </GridColumn>
              </Grid>
            </GridColumn>
          </Grid>
        </Form>
      </div>
      <div className={showResults === true ? [classes.resultPanelActive] : classes.resultPanel}>
        <div className="result-content-back-responsive" onClick={backClick}>
          <i className="arrow left icon"></i> Back
        </div>
        <div className="result-content">
          <Grid columns="2">
            <GridColumn className="rooms-available-column">
              <div className="result-available-property">
                Rooms Available at {search.property.name}
              </div>
            </GridColumn>
            <GridColumn textAlign="right" className="sort-content">
              <select onChange={onSortChange} className="sort-select">
                <option key={SORT_ITEMS.DEFAULT} value={SORT_ITEMS.DEFAULT}>
                  {SORT_ITEMS.DEFAULT}
                </option>
                <option key={SORT_ITEMS.PRICE_HIGH_TO_LOW} value={SORT_ITEMS.PRICE_HIGH_TO_LOW}>
                  {SORT_ITEMS.PRICE_HIGH_TO_LOW}
                </option>
                <option key={SORT_ITEMS.PRICE_LOW_TO_HIGH} value={SORT_ITEMS.PRICE_LOW_TO_HIGH}>
                  {SORT_ITEMS.PRICE_LOW_TO_HIGH}
                </option>
                <option
                  key={SORT_ITEMS.OCCUPANCY_LOW_TO_HIGH}
                  value={SORT_ITEMS.OCCUPANCY_LOW_TO_HIGH}
                >
                  {SORT_ITEMS.OCCUPANCY_LOW_TO_HIGH}
                </option>
                <option
                  key={SORT_ITEMS.OCCUPANCY_HIGH_TO_LOW}
                  value={SORT_ITEMS.OCCUPANCY_HIGH_TO_LOW}
                >
                  {SORT_ITEMS.OCCUPANCY_HIGH_TO_LOW}
                </option>
              </select>
            </GridColumn>
          </Grid>
          <div className={classes.content}>
            <div
              className={
                search.results.length > 0
                  ? classes.roomTypeItemContainerActive
                  : classes.roomTypeItemContainer
              }
            >
              {search.results.length > 0 &&
                search.results.map((bookingSearchByDatesResponseItem, idx) => (
                  <RoomTypeItem
                    key={bookingSearchByDatesResponseItem.roomType.id}
                    bookingSearchByDatesResponseItem={{
                      ...bookingSearchByDatesResponseItem,
                      people: search.people,
                    }}
                    bestAvailableRate={idx == 0 ? false : false}
                    defaultRoomTypeImage={property.defaultRoomTypeImage}
                    handleItemSelected={handleItemSelected}
                  ></RoomTypeItem>
                ))}
            </div>
          </div>
        </div>
      </div>
      <div className={checkoutPanelClass}>
        <div className={classes.checkoutPanelTop}>
          <Grid columns="equal">
            <GridColumn textAlign="left" onClick={() => setOpenCheckout(false)}>
              <div className={openCheckout ? classes.checkoutBackActive : classes.checkoutBack}>
                <i className="arrow left icon"></i> Back
              </div>
            </GridColumn>
            <GridColumn textAlign="center" onClick={() => setOpenCheckout(true)}>
              Checkout
            </GridColumn>
            <GridColumn textAlign="right">
              <span>${total}</span> <i className="cart icon cart-icon"></i>
            </GridColumn>
          </Grid>
        </div>
        <div className="check-out-grid-content">
          <Elements stripe={stripePromise}>
            <CheckoutPanel
              leftPanel={<LeftCheckoutPanel />}
              rightPanel={<RightCheckoutPanel />}
            ></CheckoutPanel>
          </Elements>
        </div>
      </div>
      <Container
        className={loading === true ? ['search-dimmer', 'search-dimmer-active'] : 'search-dimmer'}
      ></Container>
    </div>
  );
};
export default React.memo(Search);
